import { render, staticRenderFns } from "./addlearningmap.vue?vue&type=template&id=4f62d5ed&scoped=true"
import script from "./addlearningmap.vue?vue&type=script&lang=js"
export * from "./addlearningmap.vue?vue&type=script&lang=js"
import style0 from "./addlearningmap.vue?vue&type=style&index=0&id=4f62d5ed&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f62d5ed",
  null
  
)

export default component.exports